import axios from 'axios';
import fireWishlistEvent from '@global/gtm/wishlist';
import AlertDialog from '@global/helpers/alertDialog';

const WhishBtn = {
  name: 'WhishBtn',
  template: `
  <div>
    <a class="product-btn-whishlist" :class="{'done': isFavorite }" @click.prevent="addToWishList">WISH LIST</a>
  </div>`,
  props: {
    isFavorite: {
      type: Boolean,
    },
    CustomMarketID: {
      type: String,
      required: true,
    },
    colorID: {
      type: String || Number,
      required: true,
    },
    colorIndex: {
      type: Number,
      required: true,
    },
    selectedColor: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    productSellPrice: {
      type: Number,
      required: true,
    },
    selectedSpec: {
      type: String,
    },
  },
  methods: {
    addToWishList() {
      if (this.isFavorite) return;

      const customMarketIDWithColor = `${this.CustomMarketID.substring(
        0,
        this.CustomMarketID.indexOf('CL'),
      )}CL${this.colorID}SZ_`;

      axios
        .post(API_URL.FAVORITE, {
          CustomMarketID: customMarketIDWithColor,
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              this.$emit('handleChangeFavoriteState', this.colorIndex);
              fireWishlistEvent({
                color: this.selectedColor,
                id: customMarketIDWithColor,
                name: this.productName,
                sellPrice: this.productSellPrice,
                size: this.selectedSpec || '',
              });
            }
          } else if (res.data.Code === 401) {
            AlertDialog.alert('尚未登入');
          } else {
            AlertDialog.alert(res.data.Message);
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
  },
};

export default WhishBtn;
